import { useState, useEffect, useCallback } from "react";
import { fetchBanks, updateBankStatus, deleteBank, createBank, updateBank } from "./bankService";

export default function useBanks() {
    const [banks, setBanks] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [searchValue, setSearchValue] = useState("");
    const [status, setStatus] = useState("All")
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    const pageSize = 10;

    const loadBanks = useCallback(async () => {
        setLoading(true);
        setError("");

        try {
            const params = {
                search: searchValue || "", // fallback if empty
                status: status || "",      // fallback if empty
                page: currentPage || 1,
                limit: pageSize || 10
            };

            // console.log("params", params)
            const response = await fetchBanks(params);

            // console.log(response);
            // Extract the actual bank items and pagination
            if (response.success) {
                setBanks(response.data || []); // <-- use response.data.data
                setTotalPages(response.pagination?.total_pages || 1);
            } else {
                setBanks([]);
                setTotalPages(1);
            }
        } catch (err) {
            setError(err.response?.data?.message || "Failed to fetch banks");
        } finally {
            setLoading(false);
        }
    }, [searchValue, status, currentPage]);


    useEffect(() => {
        loadBanks();
    }, [loadBanks]);

    const handleStatusToggle = async (id, currentStatus) => {
        setLoading(true);
        setError("");
        setSuccess("");

        try {
            // console.log(id, currentStatus)
            const newStatus = currentStatus === "active" ? "inactive" : "active";
            await updateBankStatus(id, newStatus);
            setSuccess("Status updated successfully");
            loadBanks();
        } catch (err) {
            setError(err.response?.data?.message || "Failed to update status");
        } finally {
            setLoading(false);
        }
    };


    const handledeleteBank = async (id) => {
        setLoading(true);
        setError("");
        setSuccess("");

        try {
            // return;
            await deleteBank(id);
            setSuccess("Bank deleted successfully");
            loadBanks();
        } catch (err) {
            setError(err.response?.data?.message || "Failed to delete bank");
        } finally {
            setLoading(false);
        }
    };


    // create bank
    const saveBank = async (bankData) => {
        setLoading(true);
        setError("");
        setSuccess("");

        console.log(bankData);
        try {
            const response = await createBank(bankData);
            console.log(response);
            setSuccess("Bank created successfully");
            loadBanks();
        } catch (err) {
            setError(err.response?.data?.message || "Failed to create bank");
        } finally {
            setLoading(false);
        }
    };

    // update bank
    const updateBankData = async (id, bankData) => {
        setLoading(true);
        setError("");
        setSuccess("");

        try {
            await updateBank(id, bankData);
            setSuccess("Bank updated successfully");
            loadBanks();
        } catch (err) {
            setError(err.response?.data?.message || "Failed to update bank");
        } finally {
            setLoading(false);
        }
    };

    return {
        banks,
        searchValue,
        setStatus,
        status,
        setSearchValue,
        currentPage,
        totalPages,
        loading,
        error,
        success,
        handlePageChange: setCurrentPage,
        handleStatusToggle,
        handledeleteBank,
        saveBank,
        updateBankData,
        resetAlerts: () => {
            setError("");
            setSuccess("");
        },
        setCurrentPage,
    };
}
